import script from "./WeChatConsult.vue?vue&type=script&setup=true&lang=js"
export * from "./WeChatConsult.vue?vue&type=script&setup=true&lang=js"

import "./WeChatConsult.vue?vue&type=style&index=0&id=079ff6b6&lang=scss"

const __exports__ = script;

export default __exports__